import { Form, type FormItemProps, Select, type SelectProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

const { Option } = Select;

interface DropdownProps extends SelectProps<any>, FormItemProps, Ii18nLabel {
  children: any;
}

export function Dropdown({
  allowClear = true,
  options,
  name,
  label,
  i18nLabel,
  rules,
  showSearch = true,
  optionFilterProp = 'children',
  ...props
}: DropdownProps) {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item name={name} label={fieldLabel} rules={rules}>
      <Select {...props} allowClear={allowClear} showSearch={showSearch} optionFilterProp={optionFilterProp}>
        {options.map((item: any) => (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}
